import Image from "next/image";
import { useState } from "react";

import { useCatalogPageContext } from "shared/catalog/CatalogPageContext/useCatalogPageContext";
import { Button } from "ui/Button";
import { useI18n } from "utils/with-i18n.utils";

import { CatalogFilters } from "./CatalogFilters";
import { CatalogSorting } from "./CatalogSorting";

export const CatalogStickySection = () => {
  const i18n = useI18n();
  const { filters, sorting } = useCatalogPageContext();
  const filtersCount = Object.values(filters).reduce((acc, filter) => acc + filter.length, 0);
  const [filtersAreOpened, setFiltersAreOpened] = useState(false);
  
  return (
    <div className="flex z-40 justify-center items-center py-5 w-full bg-white border-y border-black/20">
      <div className="flex gap-1 justify-center items-center w-full max-w-xs cursor-pointer" onClick={() => setFiltersAreOpened(true)}>
        <p className="text-sm">{i18n.t('catalog.filters.title')}</p>
        <div className="flex relative items-center">
          <Image src="/images/catalog/icons/filters.svg" width={14} height={14} alt="filters" />
          {filtersCount > 0 && (
            <span className="absolute -top-2 -right-4 px-1.5 h-4 text-xs text-white bg-black rounded-full">{filtersCount}</span>
          )}
        </div>
      </div>

      <div className="w-px h-10 bg-black/20" />

      <div className="flex relative gap-1 justify-center items-center w-full max-w-xs cursor-pointer">
        <p className="text-sm">{i18n.t(`catalog.sorting.opt.${sorting}`)}</p>
        <Image src="/images/catalog/icons/sorting.svg" width={14} height={14} alt="sorting" />

        <div className="absolute top-0 left-0 w-full h-full opacity-0">
          <CatalogSorting />
        </div>
      </div>

      {/* Filters menu */}
      { filtersAreOpened && <FiltersSheet onClose={() => setFiltersAreOpened(false)} /> }
    </div>
  );
};


const FiltersSheet = (props: {onClose: () => void}) => {
  const i18n = useI18n();
  const { resetFilters } = useCatalogPageContext();

  return (
    <div className="flex fixed top-0 left-0 w-screen h-[100dvh]">
      <div className="overflow-y-scroll overscroll-none px-5 pt-5 w-72 h-full bg-white">
        <CatalogFilters hideGlobalFilters={true} />

        {/* Sticky buttons */}
        <div className="flex sticky bottom-0 flex-col gap-5 items-center pb-5 mt-3 bg-white">
          <Button className="w-full" onClick={() => props.onClose()}>
            {i18n.t('catalog.filters.apply')}
          </Button>
          <p className=" underline cursor-pointer" onClick={() => {resetFilters(); props.onClose()}}>
            {i18n.t('catalog.filters.reset')}
          </p>

          {/* Shadow */}
          <div className="absolute bottom-full w-full h-12 bg-gradient-to-t from-lotion to-transparent" />
        </div>
      </div>

      {/* Grey area */}
      <div className="flex-1 h-full bg-black/40" onClick={() => props.onClose()} />
    </div>
  )
}
